import React from 'react';
import { Paper } from '@material-ui/core';

// Format helpers shared by the KPI cards.
const fmtInt = (n) => Math.round(n).toLocaleString();
const fmtPct = (n) => `${(n * 100).toFixed(1)}%`;

const Delta = ({ current, prior, invert }) => {
  // invert=true means "down is good" (not used today, kept for reuse).
  if (prior === 0 && current === 0) {
    return <span className="insights__kpi-delta flat">—</span>;
  }
  const diff = current - prior;
  const pct = prior === 0 ? null : (diff / prior) * 100;
  const positive = invert ? diff < 0 : diff > 0;
  const cls = diff === 0 ? 'flat' : positive ? 'up' : 'down';
  const arrow = diff === 0 ? '' : diff > 0 ? '▲' : '▼';
  const label =
    pct === null ? 'new' : `${Math.abs(pct).toFixed(0)}% vs prior`;
  return (
    <span className={`insights__kpi-delta ${cls}`}>
      {arrow} {label}
    </span>
  );
};

const Card = ({ label, value, current, prior, invert }) => (
  <Paper className="insights__kpi-card" variant="outlined">
    <div className="insights__kpi-label">{label}</div>
    <div className="insights__kpi-value">{value}</div>
    <Delta current={current} prior={prior} invert={invert} />
  </Paper>
);

const KpiRow = ({ kpis }) => {
  if (!kpis) return null;
  const { scans, products, checkouts, viewToSample } = kpis;
  return (
    <div className="insights__kpi-row">
      <Card
        label="Total Scans"
        value={fmtInt(scans.current)}
        current={scans.current}
        prior={scans.prior}
      />
      <Card
        label="Unique Products"
        value={fmtInt(products.current)}
        current={products.current}
        prior={products.prior}
      />
      <Card
        label="Sample Checkouts"
        value={fmtInt(checkouts.current)}
        current={checkouts.current}
        prior={checkouts.prior}
      />
      <Card
        label="View → Sample Rate"
        value={fmtPct(viewToSample.current)}
        current={viewToSample.current}
        prior={viewToSample.prior}
      />
    </div>
  );
};

export default KpiRow;
